import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { sanityClient } from '../../sanity/client.js';
import { teamQuery } from '../../sanity/queries.js';
import background from '../../assets/Team/background.png';


// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import './Team.css'

const Team = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    sanityClient.fetch(teamQuery).then(setData);
  }, []);

  if (!data || !data.members) return null;

  return (
    <motion.section
      className="team-container"
      id="team"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <div className="blur team-blur-1"></div>
      <div className="blur team-blur-2"></div>
      <div className="team-header">
        {data.titleParts.map((part, i) => (
          <span
            key={i}
            className={part.style === "stroke" ? "stroke-text" : ""}
          >
            {part.text}
          </span>
        ))}
      </div>

      {/* Team Cards */}
      <div className="swiper-container">
        <Swiper
          effect={"coverflow"}
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={"auto"}
          coverflowEffect={{
            rotate: 70,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: false,
          }}
        >
          {/* Members */}
          {data.members.map((team, i) => (
            <SwiperSlide key={i}>
              <div className="team-box">
                <div className="t-b-img">
                  <img className="background" src={background} alt="" />
                  <img className="member" src={team.image.asset.url} alt={team.name} />
                </div>
                <div className="t-b-text">
                  <strong>{team.name}</strong>
                  <span>{team.belt}</span>

                  <div className="team-social">{/* Social */}</div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </motion.section>
  );
}

export default Team